module.exports = __webpack_public_path__ + "img/954-f810a9.png";